// import { Card, Metric, Text } from "@tremor/react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
});

//TODO: Change name for Messages and in all implementations
const listMessages = (message) => {
  let messagesStrings = "";

  for (let index = 0; index < message.length; index++) {
    messagesStrings += `<li> ${message[index]} </li>`;
  }
  const messageList = `<ul className="p-0"> ${messagesStrings}</ul>`;
  return messageList;
};

export const AlertBox = ({ color, messages = [] }) => {
  return Toast.fire({
    icon: color,
    title: listMessages(messages),
  });
  // return (
  //   <Card className="max-w-xs mx-auto" decoration="top" decorationColor={color}>
  //     <Text>{title}</Text>
  //     <Metric>{textError}</Metric>
  //   </Card>
  // );
};

AlertBox.propTypes = {
  color: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
  errors: PropTypes.array,
  // title: PropTypes.string,
};
